import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F8FF]">
        <Loader2 className="h-8 w-8 animate-spin text-[#1452F0]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
